import { AppLanguage } from "@aston/foundation";

import { IAccountInformationModel } from "../models";
import { IUserItemApi } from "../models/api";


export function mapToAccountInformationModel(model: IUserItemApi): IAccountInformationModel {
	return {
		id: model.id,
		fullName: model.fullName,
		isSupport: model.isSupport,
		language: (model.languageCulture ? model.languageCulture.split('-')[0] : null) as AppLanguage,
		userPrefs: model.userPrefs || {},
		hasFederationOrSubsidiary: model.hasFederationOrSubsidiary,
	}
}
